module.exports = __webpack_public_path__ + "static/media/aeroplano.ba609da6.png";